import { NgModule } from '@angular/core';

import { Section08Component } from './section08.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        Section08Component
    ],
    imports: [
        TranslateModule,
        CommonModule
    ],
    exports: [
        Section08Component
    ]
})

export class Section08Module { }
